/**
* Created by su0012004  on 2020/8/20.
*/


const Config =  new Object();
Config.site_id = 2;

Config.accept = {
  image:['image/png', 'image/gif', 'image/jpeg', 'image/bmp', 'image/x-icon'],
  video:['video/mp4','video/avi', 'video/quicktime', 'video/msvideo', 'video/x-msvideo', 'video/mpeg'],
};
Config.accept.image_str = Config.accept.image.toString();
Config.accept.video_str = Config.accept.video.toString();

// accept="image/png, image/gif, image/jpeg, image/bmp, image/x-icon"
// data:image/gif;base64,base64编码的gif图片数据
// data:image/png;base64,base64编码的png图片数据
// data:image/jpeg;base64,base64编码的jpeg图片数据
// data:image/x-icon;base64,base64编码的icon图片数据
Config.Tips = {
'cover_upload_file_size': '上传图片文件大小不能超过 3M ',
'cover_upload_file_type': '支持的图片格式有 .jpg , .png , .gif',

'video_upload_file_size': '上传视频文件大小不能超过 7M, ',
'video_upload_file_type': '支持视频文件格式有 .mp4 , .avi,',
}

Config.variable = {
    'cover_upload_file_size':0,
    'video_upload_file_size':0,
}

Config.formItem = {

'is_vip_all'      : [{value:-1,label:'不限VIP'},{value:0,label:'不需要VIP'},{value:1,label:'需要VIP✓'}],
'is_vip'      : [{value:0,label:'不需要VIP'},{value:1,label:'需要VIP✓'}],

'is_top_all'      : [{value:-1,label:'不限推荐'},{value:0,label:'正常'},{value:1,label:'推荐✓'}],
'is_top'        : [{value:0,label:'正常'},{value:1,label:'推荐✓'}],
'status_options'    : [{value: -1, label: "不限状态" }, { value: 1, label: "正常✓" },{ value: 0, label: "关闭" }],
'status_options2'   : [{value: 1, label: "正常✓" }, { value: 0, label: "关闭" }],
'is_private_all'    : [{value:-1,label:'不限权限'},{value: 1, label: "私有" }, { value: 0, label: "公共" }],
'is_private'      : [{value: 1, label: "私有" }, { value: 0, label: "公共" }],
'is_shenhe_all'     : [{value:-1,label:'不限审核'},{value: 1, label: "通过✓" }, { value: 0, label: "不通过" }],
'is_shenhe'       : [{value: 1, label: "通过✓" }, { value: 0, label: "不通过" }],


'is_verification_all'     : [{value:-1,label:'不限审核'},{value: 0, label: "未开始" },{value: 1, label: "审核中" }, { value: 2, label: "通过✓" }, { value: 3, label: "不通过" }],
'is_verification'     : [{value: 1, label: "审核中" }, { value: 2, label: "审核✓" }, { value: 3, label: "不通过" }],
'is_verification_admin'     : [{ value: 2, label: "通过✓" }, { value: 3, label: "不通过" }],



// 用户的性别，值为1时是男性，值为2时是女性，值为0时是未知
'is_sex_all'       : [{value:-1,label:'不限男女'},{value: 1, label: "男" },{value: 2, label: "女" }, { value: 0, label: "未知" }],
'is_sex'       : [{value: 1, label: "男" },{value: 2, label: "女" }, { value: 0, label: "未知" }],
//return row.sex == 2 ? '男' : row.sex == 1 ? '女' : '未知'  //用户的性别，值为1时是男性，值为2时是女性，值为0时是未知
};








Config.proxy_upload_url = '/service_img/index/Upload/post.html?t=123456789';/* 上传图片*/
Config.proxy_upload_video = '/service_img/index/Upload/upload_video.html?t=987654321'; /*上传视频音频*/
Config.proxy_upload_appendix = '/service_img/index/Upload/post_appendix.html?t=0123';  /*上传附件*/



Config.subkey = 'WCIBZ-HV7RU-Y26VG-26IQV-AWBMK-AMBOH'; //描述： 小程序地图 globalData.subkey

Config.wx_appId = '';         /**  微信 appId  **/
Config.wx_appsecret = '';         /**  微信 appsecret  **/
Config.wx_token = '';         /**  微信 token  **/



// Config.domain = 'http://ylgd.weitaotao.vip';              /**  请求主域名        这里必须初始化     **/
// Config.domain_img = 'http://ylgd.weitaotao.vip/service_img/';   /**  请求图片资源域名   这里必须初始化     **/
// Config.domain_qiniuoss = 'http://ylgd.weitaotao.vip';      /**  请求七牛云域名     这里必须初始化     **/





// Config.domain = 'http://heng_weitaotao_vip';              /**  请求主域名        这里必须初始化     **/
// Config.domain_img = 'http://heng_weitaotao_vip';   /**  请求图片资源域名   这里必须初始化     **/
//Config.domain_qiniuoss = 'http://http://sw_weitaotao_vip/';      /**  请求七牛云域名     这里必须初始化     **/



Config.clientId = 'c6472820fea24c41eda8c281c1af2fbf';  /**  客户端信息-id     **/
Config.clientSecret = '2f5ad9c68419b4d928ee9c777f4d8897';  /**  客户端信息-密码    **/






Config.strlen = function (content,len){
    try{
        var reg = /[;；]/g;
            content = content + '';
          if (content.length > 0) {
              content = content.replace(reg,"$&\r\n");
              if (content.length > len) {
                return content.slice(0,len) + '...' //长度大于10的后面用......代替
              }
              return content;
          }else{
             return  '';
          }
    }catch(e){

        console.info('eeeee', e)
        //TODO handle the exception
    }
       return  '';
 }



Date.prototype.format = function (fmt) { //author: meizz
    let ret;
        const opt = {
            "Y+": this.getFullYear().toString(),        // 年
          //  "m+": (this.getMonth() + 1).toString(),     // 月
             "M+": (this.getMonth() + 1).toString(),     // 月
          //  "d+": this.getDate().toString(),            // 日
             "D+": this.getDate().toString(),            // 日
            "H+": this.getHours().toString(),           // 时
          //  "M+": this.getMinutes().toString(),         // 分
             "m+": this.getMinutes().toString(),         // 分
               "s+": this.getSeconds().toString(),          // 秒
            "S+": this.getSeconds().toString()          // 秒
            // 有其他格式化字符需求可以继续添加，必须转化成字符串
        };
        for (let k in opt) {
            ret = new RegExp("(" + k + ")").exec(fmt);
            if (ret) {
                fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
            };
        };
        return fmt;
}

// el-table-column
/**
*
* 时间格式  --  适用列表
*/
Config.formatter_dateFormat = function(row, column){
    let date =  row[column.property]
    if (date == undefined || date == 0 || date == '') {
        return "";
    }
    date = date * 1000;
   return (new Date(date)).format("YYYY-MM-DD HH:mm:ss");
   // return moment(date).format("YYYY-MM-DD HH:mm:ss");
},

// el-table-column
Config.formatter_is_vip = function(row, column){
     let _index =  row[column.property]
    let name = '未知';
     Config.formItem.is_vip_all.forEach(function(item,index){
     if ( item.value === _index ){
          name = item.label + '';
     }
    });
  return  name ;
}


// el-table-column
Config.formatter_is_verification = function(row, column){
     let _index =  row[column.property]
    let name = '未知';
     Config.formItem.is_verification_all.forEach(function(item,index){
     if ( item.value === _index ){
          name = item.label + '';
     }
    });
  return  name ;
}

// el-table-column
Config.formatter_topName = function(row, column) {
         let _index =  row[column.property]
        let _arr =  Config.formItem.is_top_all;
        let _name = '未知';
        for(let i = 0; i < _arr.length; i++){
            if(_arr[i].value === _index ){
                 _name = _arr[i].label  + '';
                 break;
            }
        }
        return _name;
    }

// el-table-column
Config.formatter_statusName = function (row, column) {

        let _index =  row[column.property]
        let _arr =  Config.formItem.status_options;
        let _name = '未知';
        for(let i = 0; i < _arr.length; i++){
            if(_arr[i].value === _index ){
                 _name = _arr[i].label + '';
                 break;
            }
        }
        return _name;
    },

// is_sex_all
Config.formatter_sex = function (row, column) {

        let _index =  row[column.property]
        let _arr =  Config.formItem.is_sex_all;
        let _name = '未知';
        for(let i = 0; i < _arr.length; i++){
            if(_arr[i].value == _index ){
                 _name = _arr[i].label + '';
                 break;
            }
        }
        return _name;
    },


Config.returnFloat = function (value){
     var value=Math.round(parseFloat(value)*100)/100;
     var xsd=value.toString().split(".");
     if(xsd.length==1){
        value=value.toString()+".00";
        return value;
     }
     if(xsd.length>1){
         if(xsd[1].length<2){
            value=value.toString()+"0";
         }
         return value;
     }
}
/**  :formatter="this.GLOBAL.formatter_amount"  */
Config.formatter_amount = function (row, column) {
        let _index =  row[column.property]
        _index   = _index / 100; /**  转换成以 "分=>元"为单位  */
        return Config.returnFloat(_index);
    }





Config.handleError = function(_that,res,file){
    const that = this;
    that.$message.warning(res.info);
}


Config.beforeAvatarUpload = function(_that,file) {
        const that = _that;//this;
        const Size = 3;// //2MB!
     let isJPG = false;
                 switch (file.type) {
                     case "image/png":
                         isJPG = true;
                         break;
                     case "image/jpeg":
                         isJPG = true;
                         break;
                  case "image/gif":
                      isJPG = true;
                      break;

                     default:
                         isJPG = false;
                         break;
                 }
        const isLt2M = file.size / 1024 / 1024 < Size; //2MB!
        if (!isJPG) {
          that.$message.error('上传的图片只能是 JPG/png/gif 格式!');
          that.fileList =[];//清空上传后的文件列表
        }
        if (!isLt2M) {
          that.$message.error(`上传的图片大小不能超过 ${Size} MB!`);
          that.fileList =[];//清空上传后的文件列表
        }
        return isJPG && isLt2M;
}

/*
video/mp4 *.mp4
audio/mp4 *.mp4
audio/mpeg  *.mp3
*/
Config.beforeVideoUpload = function(_that,file) {
        const that = _that;//this;
        const Size = 20;// //2MB!
        let isJPG = false;
                 switch (file.type) {
                     case "video/mp4":
                         isJPG = true;
                         break;
                     case "audio/mp4":
                         isJPG = true;
                         break;
                    case "audio/mpeg":
                        isJPG = true;
                        break;
                     default:
                         isJPG = false;
                         break;
                 }
        const isLt2M = file.size / 1024 / 1024 < Size; //2MB!
        if (!isJPG) {
          that.$message.error('上传的视频只能是 mp4/mp3 格式!');
          that.fileList =[];//清空上传后的文件列表
        }
        if (!isLt2M) {
          that.$message.error(`上传的视频大小不能超过 ${Size} MB!`);
          that.fileList =[];//清空上传后的文件列表
        }
        return isJPG && isLt2M;
}








if (process.env.ENV_NAME === 'development') {
console.info('development 就会获取到所配置的变量值::',process.env);//就会获取到所配置的变量值；
} else if (process.env.ENV_NAME === 'testing') {
console.info('testing 就会获取到所配置的变量值::',process.env);//就会获取到所配置的变量值；
} else if (process.env.ENV_NAME === 'production') {
console.info('testing 就会获取到所配置的变量值::',process.env);//就会获取到所配置的变量值；
} else {
console.info('不知道是什么环境了 就会获取到所配置的变量值::',process.env);//就会获取到所配置的变量值；
}
Config.domain = process.env.SERVICE_API_URL;              /**  请求主域名        这里必须初始化     **/
Config.domain_img =  process.env.SERVICE_IMG_URL;   /**  请求图片资源域名   这里必须初始化     **/

Config.domain = 'http://sw_weitaotao_vip/'
Config.domain_img = 'http://sw_weitaotao_vip/service_img'




Config.domain = 'http://sw.weitaotao.vip/'

Config.domain_img = 'http://sw.weitaotao.vip/service_img'



module.exports = Config;



// WEBPACK FOOTER //
// ./src/components/config/config.js